import { isMethodFeeWaived } from '@/components/wallet/shared/depositMethodTypes';

export default {
  computed: {
    feeWaivedBannerTxt() {
      const method = this.methods.find((m) => isMethodFeeWaived(m) && m.feeStateBannerTxt);
      return method ? method.feeStateBannerTxt : '';
    },
  },
};
